import React from 'react';
import { Layout } from '../components/Layout';
import { BrandList } from '../components/almacenes/BrandList';

const AlmacenesPage: React.FC = () => {
  return (
    <Layout>
      <div className="p-6 max-w-7xl mx-auto">
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-gray-900">Catálogo de Almacenes</h1>
          <p className="text-gray-500 mt-1">Administración centralizada de Marcas, Colores y Tallas.</p>
        </div>

        <BrandList />
      </div>
    </Layout>
  );
};

export default AlmacenesPage;